import { DentalApi } from "../helpers/DentalApi";

export const httpClient = new DentalApi();
